// React
import { useState } from 'react';

import type { SingleKeyAction } from '@/utils/hooks/homeKeyActions/useKeyActions';

// Components
import Icon from '@/components/base/Icon';

type ActionLinkProps = Pick<SingleKeyAction, 'title' | 'icon' | 'hoverIcon' | 'onClick'>;

export const ActionLink = ({ title, icon, hoverIcon, onClick }: ActionLinkProps) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <button
            className="flex cursor-pointer items-center justify-between gap-4 p-4 font-GBold text-base"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={onClick}>
            <div className="flex w-full items-center justify-between gap-2">
                <span className="flex items-center">
                    <span className="flex items-center justify-center gap-2 rounded-md bg-icoGray-100 p-2">
                        <Icon
                            className={`text-l text-icoBlack`}
                            icon={isHovered ? hoverIcon : icon}
                        />
                    </span>
                    <span className="text-l ml-2 text-icoBlack dark:text-white">{title}</span>
                </span>
                <Icon data-testid="arrow-right" icon="arrow-right" className="text-icoGray-400" />
            </div>
        </button>
    );
};
